<template>
  <div class="footer-wrapper">
    <div class="pc-footer-wrapper hidden-sm-and-down">
      <div class="footer-content share-content-1200 clearfix">
        <div class="left clearfix">
          <ul>
            <li>
              <h2>关于我们</h2>
            </li>
            <li>
              <span>关于和风</span>
            </li>
            <li>
              <span>加入我们</span>
            </li>
            <li>
              <span>联系我们</span>
            </li>
          </ul>
          <ul>
            <li>
              <h2>使用帮助</h2>
            </li>
            <li>
              <span>媒体报道</span>
            </li>
            <li>
              <span>法律声明</span>
            </li>
            <li>
              <span>使用指导</span>
            </li>
          </ul>
          <ul>
            <li>
              <h2>意见反馈</h2>
            </li>
            <li>
              <span>投诉邮箱：xujie@ijobwind.com</span>
            </li>
            <li @click="openQQ(3335698724)">
              <span>技术支持：QQ3335698724</span>
            </li>
            <li>
              <span>就职咨询：021-31576331</span>
            </li>
          </ul>
        </div>
        <div class="right">
          <ul class="clearfix">
            <li>
              <span class="tel">
                <i></i>
              </span>
              <div class="tel">
                <img src="../../../static/images/tel.png" alt="021-31576331">
                <!-- <img src="../../../static/images/wx.jpg" alt="微信图片"> -->
              </div>
            </li>
            <li>
              <span class="qq" @click="openQQ(2829824831)">
                <i></i>
              </span>
            </li>
            <li>
              <span class="wx">
                <i></i>
              </span>
              <div>
                
                <img src="../../../static/images/wx.jpg" alt="微信图片">
              </div>
            </li>
            <li>
              <span class="wb">
                <i></i>
              </span>
              <div>
                <img src="../../../static/images/wb.jpg" alt="微信图片">
              </div>
            </li>
          </ul>

          <p>
            <span>Copyright ©2018 - {{newYearDate}} ijobwind.com
            <br>All Rights Reserved</span>
            <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备05001125号-21</a>
          </p>
        </div>
      </div>
    </div>

    <!-- 移动端 copy -->
    <div class="m-footer-content hidden-md-and-up">
      <p>
        <span>Copyright ©2018 - {{newYearDate}} ijobwind.com，All Rights Reserved</span>
        <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备05001125号-21</a>
      </p>
    </div>
    <!-- 移动端 底部导航 -->
    <div class="m-footer-nav hidden-md-and-up">
      <ul class="clearfix">
        <li v-for="item in footNav">
          <router-link :to="item.path" :class="routeName == item.name?'active':''">
            <i></i>
            <p>{{item.txt}}</p>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newYearDate: new Date().getFullYear(),
      routeName: "",
      footNav: [
        {
          path: "/index",
          name: "index",
          txt: "首页"
        },
        {
          path: "/recruitIndex",
          name: "recruitDetail",
          txt: "职位"
        },
        {
          path: "/advantage",
          name: "advantage",
          txt: "优势"
        },
        {
          path: "/policyIndex?tab=0",
          name: "policyDetail",
          txt: "资讯"
        }
      ]
    };
  },
  methods: {
    openQQ(qq){
      window.open('http://wpa.qq.com/msgrd?v=3&uin='+ qq +'&site=qq&menu=yes')
    }
  },
  watch: {
    $route(to, form) {
      // 监听路由变化 给对应的子路由加上active状态
      this.routeName = to.name;
    }
  }
};
</script>

<style lang="less">
.pc-footer-wrapper {
  position: relative;
  width: 100%;
  background-color: #28282e;
  .footer-content {
    padding: 0.55rem 0;
    // width: 62.5%;
    // margin: 0 auto;
    // width: 1200px;
    // height: 2.4rem;
    .left {
      & > ul {
        margin-right: 0.9rem;
        float: left;
        li {
          margin-bottom: 0.18rem;
          line-height: 1;
          cursor: pointer;
          h2 {
            font-size: 0.14rem;
            color: #ffffff;
            font-weight: 700;
          }
          span {
            font-size: 0.12rem;
            color: #76767b;
          }
          &:first-child {
            margin-bottom: 0.22rem;
          }
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .right {
      ul {
        margin-bottom: 0.1rem;
        li {
          position: relative;
          float: right;
          cursor: pointer;
          span {
            position: relative;
            display: block;
            width: 0.6rem;
            height: 0.6rem;
            i {
              position: absolute;
              top: 50%;
              left: 50%;
              display: block;
              background: url("../../../static/images/footIcon.png") no-repeat;
              background-size: 1.13rem 0.29rem;
              transform: translate(-50%, -50%);
            }
          }
          div {
            opacity: 0;
            filter: alpha(opacity=0);
            transform: translateX(-50px);
            transition: transform 0.5s;
            position: absolute;
            right: 0;
            bottom: 0.75rem;
            width: 1.2rem;
            height: 1.2rem;
            img{
              width: 100%;
            }
            &.tel{
              width: 1.64rem;
              height: .26rem;
            }
          }
          &:nth-child(4) {
            span {
              i {
                width: 0.3rem;
                height: 0.26rem;
                background-position: -0.82rem 0;
              }
            }
          }
          &:nth-child(3) {
            span {
              i {
                width: 0.3rem;
                height: 0.26rem;
                background-position: -0.5rem 0;
              }
            }
          }
          &:nth-child(2) {
            span {
              i {
                width: 0.24rem;
                height: 0.26rem;
                background-position: 0 0;
              }
            }
          }
          &:nth-child(1) {
            span {
              i {
                width: 0.28rem;
                height: 0.28rem;
                background-position: -0.22rem 0;
              }
            }
          }

          &:hover {
            span {
              background: #15151a;
            }
            div {
              opacity: 1;
              filter: alpha(opacity=100);
              transform: translateX(0);
            }
          }
        }
      }

      p {
        text-align: right;
        font-size: 0.14rem;
        line-height: 1.8;
        color: #76767b;
        a{
          display: block;
          color: #76767b;
          &:hover{
            color: #7e8c8d;
          }
        }
      }
    }
  }
}

// 移动端
.m-footer-content {
  padding-bottom: 0.75rem;
  p {
    padding: 0.15rem 0;
    color: #a1a1a1;
    text-align: center;
    font-size: 0.09rem;
    background-color: #e9e9e9;
    a{
      display: block;
      color: #a1a1a1;
    }
  }
}
.m-footer-nav {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 100;
  width: 100%;
  padding: 0.17rem 0.1rem 0.14rem;
  background: #ffffff;
  box-shadow: 0 0 0.15rem rgba(0, 0, 0, 0.14);
  li {
    float: left;
    width: 25%;
    text-align: center;
    a {
      display: inline-block;
      font-size: 0;
      i {
        display: inline-block;
        width: 0.25rem;
        height: 0.24rem;
        background: url("../../../static/images/m/mFootIcon.png") no-repeat 0 0;
        background-size: 0.885rem 0.49rem;
      }
      p {
        margin-top: 0.06rem;
        font-size: 0.12rem;
        line-height: 1;
        color: #878787;
      }
      &.router-link-active,
      &.active {
        i {
          background-position: 0 -0.25rem;
        }
        p {
          color: #0f8ffd;
        }
      }
    }

    &:nth-child(2) {
      a {
        i {
          background-position: -0.25rem 0;
        }
        &.router-link-active,
        &.active {
          i {
            background-position: -0.25rem -0.25rem;
          }
        }
      }
    }
    &:nth-child(3) {
      a {
        i {
          width: 0.185rem;
          background-position: -0.5rem 0;
        }
        &.router-link-active,
        &.active {
          i {
            background-position: -0.5rem -0.25rem;
          }
        }
      }
    }
    &:nth-child(4) {
      a {
        i {
          width: 0.185rem;
          background-position: -0.7rem 0;
        }
        &.router-link-active,
        &.active {
          i {
            background-position: -0.7rem -0.25rem;
          }
        }
      }
    }
  }
}

.share-content-1200{
  width: 62.5%;
  margin: 0 auto;
}
@media screen and (max-width: 1680px){
  .share-content-1200{
    width: 72.5%;
    margin: 0 auto;
  }
}
@media screen and (max-width: 1440px){
  .share-content-1200{
    width: 82.5%;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/foot.vue